// What the scene needs to draw a ghost of the blueprint mode: its cells, which way each belt cell
// points, the machine and its turn, and whether it fits.
import { sideTowards, type Cell, type Rotation, type Side } from '../sim/geometry';
import type { Ghost } from './build-session';

export type BuildGhost =
  | { readonly kind: 'belt'; readonly cells: readonly Cell[]; readonly sides: readonly Side[]; readonly fits: boolean }
  | { readonly kind: 'machine'; readonly machine: string; readonly cells: readonly Cell[]; readonly rotation: Rotation; readonly fits: boolean };

export function buildGhost(ghost: Ghost): BuildGhost {
  const draft = ghost.draft;
  if (draft.kind === 'machine') return { kind: 'machine', machine: draft.machine, cells: ghost.cells, rotation: draft.rotation, fits: ghost.fits };
  const sides = draft.path.map((cell, i) => {
    const next = draft.path[i + 1];
    return (next && sideTowards(cell, next)) ?? draft.exit;
  });
  return { kind: 'belt', cells: draft.path, sides, fits: ghost.fits };
}
